import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["content"]

import InlineSvg from "vue-inline-svg";
import { computed } from "vue";
import { TranslateResult } from "vue-i18n";

export interface Props {
  name: string | TranslateResult;
  color?: string;
  colorTag?: string;
  size?: string;
  tooltip?: string | TranslateResult;
  tooltipSettings?: object;
  spin?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VIconSvg',
  props: {
    name: { default: "" },
    color: { default: "" },
    colorTag: { default: "fill" },
    size: { default: "md" },
    tooltip: { default: "" },
    tooltipSettings: { default: () => ({}) },
    spin: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const wrapperClasses = computed(() => {
  const name = `icon-${props.name}`;
  const tag = `icon-svg-${props.colorTag}`;
  const color = `icon-color-${props.color}`;
  const size = `icon-size-${props.size}`;

  return [name, tag, color, size];
});

const inlineSvgClasses = computed(() => {
  return {
    "animate-spin": props.spin,
  };
});

const iconPath = computed(() => {
  return require(`@/assets/icons/${props.name}.svg`);
});

const tippyConfig = computed(() => {
  return { onShow: () => !!props.tooltip, ...props.tooltipSettings };
});

const onClick = () => {
  emit("click");
};

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createElementBlock("span", {
    content: _ctx.tooltip,
    class: _normalizeClass(["icon-svg", wrapperClasses.value]),
    onClick: onClick
  }, [
    _createVNode(_unref(InlineSvg), {
      src: iconPath.value,
      class: _normalizeClass(inlineSvgClasses.value)
    }, null, 8, ["src", "class"])
  ], 10, _hoisted_1)), [
    [_directive_tippy, tippyConfig.value]
  ])
}
}

})